<script setup>
import {
  buildMtgsLoaderScript,
  MTGS_CONTAINER_LIVE,
  MTGS_CONTAINER_STAGING,
  MTGS_LOADER_QUERY_LIVE,
  MTGS_LOADER_QUERY_STAGING,
} from '~/utils/mtgsLoader'

const config = useRuntimeConfig()
const domain = (config.public.domain || 'https://luma-delikatessen.ch').replace(/\/$/, '')
const isStaging = domain.includes('staging')
const loaderBase = (config.public.mtgsLoaderBase || `${domain}/mtgs`).replace(/\/$/, '')
const loaderQuery = config.public.mtgsLoaderQuery || (isStaging ? MTGS_LOADER_QUERY_STAGING : MTGS_LOADER_QUERY_LIVE)
const noscriptBase = (config.public.mtgsNoscriptBase || 'https://mtgs.luma-delikatessen.ch').replace(/\/$/, '')
const containerId = config.public.mtgsContainerId || config.public.scripts?.googleTagManager?.id || (isStaging ? MTGS_CONTAINER_STAGING : MTGS_CONTAINER_LIVE)

if (!import.meta.dev) {
  useHead({
    script: [
      {
        key: 'mtgs-ld',
        innerHTML: buildMtgsLoaderScript(loaderBase, loaderQuery),
        tagPriority: 1,
      },
    ],
  })
}

if (containerId) {
  const src = `${noscriptBase}/ns.html?id=${encodeURIComponent(containerId)}`
  useHead({
    noscript: [
      {
        key: 'mtgs-ns',
        innerHTML: `<iframe src="${src}" height="0" width="0" style="display:none;visibility:hidden" title=""></iframe>`,
        tagPosition: 'bodyOpen',
      },
    ],
  })
}
</script>

<template>
  <span hidden />
</template>
